import React from 'react'
import { Button, Input } from './all';
import useAluno from '../hooks/useAluno';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import toast from '../utils/toast';
import useAutoescola from '../hooks/useAutoescola';
import { Modal } from './all';

export default function FormCadastro({ autoescola_id }) {
    const { createPreCadastro } = useAluno();
    const { getAutoescola, autoescolas } = useAutoescola();
    const navigate = useNavigate();

    useEffect(() => {
        const fetchAutoescola = async () => {
            if (autoescola_id) {
                await getAutoescola({ id: autoescola_id });
            }
        };
        fetchAutoescola();
    }, []);

    const [name, setName] = useState('');
    const [cpf, setCpf] = useState('');
    const [telefone, setTelefone] = useState('');
    const [categoria_pretendida, setCategoriaPretendida] = useState('');
    const [outra_cidade, setOutraCidade] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);

    const [etapa, setEtapa] = useState(1);

    const onSubmit = async (e) => {
        e.preventDefault();
        //console.log("etapa", etapa);
        const sobrenome = name.split(" ").slice(1).join(" ");
        const primnome = name.split(" ")[0];
        if (etapa === 2) {
            //console.log(categoria_pretendida);
            if (categoria_pretendida.length === 0) {
                toast.info("Por favor, selecione ao menos uma categoria pretendida.");
                return;
            }
            setEtapa(etapa + 1);
            return;
        } else if (etapa === 1) {
            if (!name) {
                toast.info("Preencha o nome.");
                return;
            }

            if (!sobrenome) {
                toast.info("Preencha o sobrenome.");
                return;
            }

            if (!cpf) {
                toast.info("Preencha o CPF.");
                return;
            }

            if (cpf.length < 11) {
                toast.info("CPF inválido.");
                return;
            }

            if (!telefone) {
                toast.info("Preencha o telefone.");
                return;
            }

            if (telefone.length < 11) {
                toast.info("Telefone inválido.");
                return;
            }

            setEtapa(etapa + 1);
            return;
        }

        const categoriasFormatado = categoria_pretendida.join(", ").replaceAll(", ", "");

        const aluno = {
            nome: primnome,
            sobrenome: sobrenome,
            tipo_usuario: 'precadastro',
            categoria_pretendida: categoriasFormatado,
            cpf: cpf,
            telefone: telefone,
            autoescola_id: autoescola_id,
            outra_cidade: outra_cidade
        };

        const success = await createPreCadastro({ aluno });
        if (success) {
            setModalOpen(true);
        }
    }

    const RenderEtapas = () => {
        const cssPassado = "h-3 flex-1 bg-primary rounded-full transition-all duration-500 ease-in-out";
        const cssProximo = "h-3 flex-1 bg-transparent border-2 border-neutral-500 rounded-full transition-all duration-500 ease-in-out";

        return (
            <div className='flex gap-2 w-full justify-center items-center'>
                <div className={etapa >= 1 ? cssPassado : cssProximo}>

                </div>

                <div className={etapa >= 2 ? cssPassado : cssProximo}>

                </div>

                <div className={etapa >= 3 ? cssPassado : cssProximo}>

                </div>
            </div>
        )
    }

    const changeCategoriaPretendida = (e, categoria) => {
        if (e.target.checked) {
            setCategoriaPretendida([...categoria_pretendida, categoria]);
        } else {
            setCategoriaPretendida(categoria_pretendida.filter(cat => cat !== categoria));
        }
    }

    return (
        <form className='flex flex-col gap-2 w-full h-full justify-center items-center' onSubmit={(e) => onSubmit(e)}>
            <div className='flex w-full justify-start mb-8'>
                {etapa === 1 && (
                    <button className='flex gap-2 items-center' onClick={() => navigate('/')}>
                        <span className="material-icons" >
                            arrow_back
                        </span >
                        Voltar
                    </button>
                )}
            </div>
            <div className='w-full text-start mb-5'>
                <h1 className='text-3xl font-semibold'>Cadastrar-se</h1>
                <p className='text-neutral-500'>A gente cuida do resto depois <strong>😉</strong> </p>
            </div>

            <div className='flex flex-col w-full gap-2 border border-neutral-400 p-4 rounded-lg text-start'>
                {etapa === 1 && (
                    <>
                        <h1 className='text-neutral-500'>Insira os seus dados pessoais</h1>
                        <Input
                            label="Nome Completo"
                            placeholder="Digite seu nome completo"
                            required
                            value={name}
                            onChange={(e) => setName(e.target.value)} />
                        <Input
                            label="CPF"
                            placeholder="Digite seu CPF (somente números)"
                            required
                            minLength={11}
                            maxLength={11}
                            value={cpf}
                            onChange={(e) => setCpf(e.target.value)} />
                        <Input
                            label="Telefone"
                            placeholder="Digite seu telefone (somente números)"
                            required
                            value={telefone}
                            minLength={11}
                            maxLength={11}
                            onChange={(e) => setTelefone(e.target.value)} />
                    </>
                )}

                {etapa === 2 && (
                    <>
                        <div className='flex flex-col text-start gap-5'>
                            <div className='flex flex-col gap-2'>
                                <label className='text-sm text-neutral-500 mb-1'>- Você reside na mesma cidade da <strong className='text-neutral-600'>{autoescolas[0].nome || ""}</strong>, que é <strong className='text-neutral-600'>{autoescolas[0].cidade || ""}</strong>?</label>
                                <div className='flex gap-2'>
                                    <input type="radio" id="reside_sim" name="reside_cidade" value="sim" checked={!outra_cidade} onChange={() => setOutraCidade(false)} />
                                    <label htmlFor="reside_sim">Sim</label>
                                    <input type="radio" id="reside_nao" name="reside_cidade" value="nao" checked={outra_cidade} onChange={() => setOutraCidade(true)} />
                                    <label htmlFor="reside_nao">Não</label>
                                </div>
                            </div>

                            <div className='flex flex-col gap-2'>
                                <p className='text-neutral-500 text-sm'>- Qual a categoria pretendida? <strong className='text-neutral-600'>(Você pode escolher mais de uma)</strong>:</p>
                                <div className='flex flex-col gap-2 text-sm'>
                                    <div className='flex gap-1'>
                                        <input
                                            id='checkMoto'
                                            checked={categoria_pretendida.includes("a")}
                                            type='checkbox'
                                            onChange={(e) => changeCategoriaPretendida(e, "a")} />
                                        <label htmlFor="checkMoto">Moto (A)</label>
                                    </div>

                                    <div className='flex gap-1'>
                                        <input
                                            id='checkCarro'
                                            checked={categoria_pretendida.includes("b")}
                                            type='checkbox'
                                            onChange={(e) => changeCategoriaPretendida(e, "b")} />
                                        <label htmlFor="checkCarro">Carro (B)</label>
                                    </div>

                                    <div className='flex gap-1'>
                                        <input
                                            id='checkOnibus'
                                            checked={categoria_pretendida.includes("d")}
                                            type='checkbox'
                                            onChange={(e) => changeCategoriaPretendida(e, "d")} />
                                        <label htmlFor="checkOnibus">Ônibus (D)</label>
                                    </div>

                                    <div className='flex gap-1'>
                                        <input
                                            id='checkCaminhao'
                                            checked={categoria_pretendida.includes("c")}
                                            type='checkbox'
                                            onChange={(e) => changeCategoriaPretendida(e, "c")} />
                                        <label htmlFor="checkCaminhao">Caminhão (C)</label>
                                    </div>

                                    <div className='flex gap-1'>
                                        <input
                                            id='checkCarreta'
                                            checked={categoria_pretendida.includes("e")}
                                            type='checkbox'
                                            onChange={(e) => changeCategoriaPretendida(e, "e")} />
                                        <label htmlFor="checkCarreta">Carreta (E)</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}

                {etapa === 3 && (
                    <>
                        <h1 className='text-neutral-500'>Confirme os dados:</h1>
                        <ul className='flex flex-col gap-2 text-sm text-neutral-500'>
                            <li>- Nome: <strong className='text-neutral-600 capitalize'>{name}</strong></li>
                            <li>- CPF: <strong className='text-neutral-600'>{cpf}</strong></li>
                            <li>- Telefone: <strong className='text-neutral-600'>{telefone}</strong></li>
                            <li>- Categorias pretendidas: <strong className='text-neutral-600 uppercase'>{categoria_pretendida.join(", ")}</strong></li>
                            <li>- Reside em {autoescolas[0].cidade}: <strong className='text-neutral-600'>{outra_cidade ? "Não" : "Sim"}</strong></li>
                        </ul>
                    </>
                )}

            </div>
            <a className='text-start w-full text-sm text-neutral-600 mb-8'>*Todos os campos são obrigatórios</a>
            <RenderEtapas />

            <Button type={1}>
                {etapa >= 3 ? 'Finalizar Cadastro' : 'Próximo'}
                <span className='material-icons'>{etapa >= 3 ? 'check' : 'arrow_forward'}</span>
            </Button>
            {etapa >= 2 && (
                <button
                    className='bg-neutral-100 flex shadow-md h-10 rounded-lg p-6 transition-all duration-300 ease-in-out w-full text-center justify-center items-center gap-2 hover:shadow-2xl hover:bg-neutral-200 border-2 border-neutral-400 text-neutral-600'
                    type={'button'}
                    onClick={() => setEtapa(etapa - 1)}>
                    <span className='material-icons'>arrow_back</span>
                    Voltar à Etapa Anterior
                </button>
            )}

            <div className='flex flex-col text-neutral-500 text-sm'>
                <p>Ao se cadastrar você concorda com nossos </p>
                <a className='font-semibold text-neutral-700' href='https://novus-tech-brasil.github.io/politica-privacidade-apps/' target='_blank'>TERMOS E CONDIÇÕES</a>
            </div>

            <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <Modal isOpen={modalOpen}>
                <div className='min-h-[70vdh] flex flex-col gap-4'>
                    <h1 className='text-2xl font-semibold mb-4'>Pré-cadastro realizado com sucesso!</h1>
                    <p className='mb-8'>Obrigado por se cadastrar na <strong>{autoescolas[0]?.nome || ""}</strong>. Em breve, a equipe da autoescola entrará em contato com você para dar continuidade ao processo de matrícula.</p>

                    <div className='bg-green-300 border border-green-800 rounded-lg p-3 text-green-800 flex justify-center items-center gap-2 opacity-80 animate-pulse'>
                        A Autoescola já foi avisada!
                        <span class="material-icons">
                            check_circle
                        </span>
                    </div>
                    <Button type={1} onClick={() => navigate('/')}>
                        Voltar à Página Inicial
                    </Button>
                </div>
            </Modal>
        </form>
    )
}
